<template>
  <d-container fluid>
    <d-row class="mt-3 mt-md-4">
      <!-- Pages -->
      <d-col md="12" class="mb-4">
        <instant-search :algolia-index="searchIndex" :initial-settings="initial" :filters="docsFilter" :algolia-api-key="searchKey" :hits-per-page="20" :allow-blank="true">
          <d-row>
            <refinements />
            <d-col md="8" lg="9">
              <hits-card :show-pagination="true">
                <template slot="row" slot-scope="{items}">
                  <hits-list v-for="item in items" :key="item.objectID" :link="item.webViewLink" :title="item.name" :mime-type-label="item.mimeTypeLabel" :row-body="getDescription(item)" :details="getDetails(item)" />
                </template>
              </hits-card>
            </d-col>
          </d-row>
        </instant-search>
      </d-col>
    </d-row>
  </d-container>
</template>

<script>
import { mapState, mapGetters } from 'vuex';
import InstantSearch from '@/components/search/InstantSearch.vue';
import HitsCard from '@/components/search/HitsTableView.vue';
import Refinements from '@/components/search/Refinements.vue';
import Docs from '@/components/search/Docs.vue';
import moment from 'moment';

export default {
  name: 'InitiativeDocuments',
  components: {
    InstantSearch,
    Refinements,
    HitsList: Docs,
    HitsCard,
  },
  data() {
    return {
      initial: {},
    };
  }, 
  created() {
    var searchSettings = this.$store.state.searchSettings;
    for (var i = 0; i < searchSettings.facets.length; i++) {
      if(searchSettings.facets[i].urlParam in this.$route.query){
        this.initial[searchSettings.facets[i].attribute] = decodeURIComponent(this.$route.query[searchSettings.facets[i].urlParam]).split(",")
      }
    }
  },
  computed: {
    docsFilter() {
      var defaultFilter = "NOT permissionLevel:limited AND trashed:false AND order>=0 AND NOT mimeTypeLabel:'Google Sites' AND NOT owner.name:'Global Gsites AODocs' AND NOT owner.name:'Global Gsites Public AODocs' AND NOT owner.name:'SG Communication & Marketing AODocs' AND NOT owner.name:'SG Comms Public AODocs' AND NOT owner.name:'SG HR AODocs' AND NOT owner.name:'SG Edu AODocs' AND NOT owner.name:'NZ Office AODocs' AND NOT owner.name:'INT Finance AODocs' AND NOT owner.name:'INT Communication & Marketing AODocs' AND NOT owner.name:'EPO Drives AODocs' AND NOT owner.name:'Business Finance AODocs'";
      if(this.$route.query.folder) {
        defaultFilter += ` AND folders.fileId:'${this.$route.query.folder}'`
      }
      return defaultFilter
    },
    searchIndex() {
      return this.searchSettings.index;
    },
    ...mapState(['searchtext', 'showFilters', 'pageLayout', 'searchSettings']),
    ...mapGetters(['searchKey']),
  },
  methods: {
    str2Val(str, scope) {
      const keys = str.split(/[\.\[\]'"]/).filter(e => e);
      let ret = scope;
      
      try {
        keys.forEach(key => {
          ret = ret[key];
        });
        return ret;
      } catch(e) {
        return undefined;
      }
    },
    aodocsShortner(ownerName) {
      return ownerName.replace(/AODocs/i, '');
    },
    gSiteUrlShortner(urlPath) {
      return urlPath.replace('https://sites.google.com/', '.../');
    },
    getDescription(item) {
      if(this.searchSettings.attributesToDisplay && this.searchSettings.attributesToDisplay.description) {
        return this.str2Val(this.searchSettings.attributesToDisplay.description, item);
      }

      return item._highlightResult ? item._highlightResult.content.value : '' ;
    },
    getDetails(item) {
      var details = [];
      if(this.searchSettings.attributesToDisplay && this.searchSettings.attributesToDisplay.details.length){
        for (var i = 0; i < this.searchSettings.attributesToDisplay.details.length; i++) {
          var attribute = this.searchSettings.attributesToDisplay.details[i].attribute;

          var obj;

          switch (this.searchSettings.attributesToDisplay.details[i].format) {
            case 'lastModify':
              obj = moment(item.modifiedTimestamp).format('DD MMM YY')+ ' by ' +item.lastModifiedBy.name;
              break;
            default:
              obj = this.str2Val(attribute, item);
              if(Array.isArray(obj)){
                obj = obj.join(',');  
              }
              if(!obj || typeof obj !== 'string' || obj === '') {
                obj = '-';
              }
          }

          var subAttributeValue = null
          if(this.searchSettings.attributesToDisplay.details[i]['sub-attribute']) {
            var subAttributekey = this.searchSettings.attributesToDisplay.details[i]['sub-attribute'].value;
            var subAttributeObj = this.str2Val(subAttributekey, item);
            var endVal = Array.isArray(subAttributeObj) ? subAttributeObj.join(',') : subAttributeObj;
            
            if(subAttributeObj && (!this.searchSettings.attributesToDisplay.details[i]['sub-attribute'].requiredValue || this.searchSettings.attributesToDisplay.details[i]['sub-attribute'].requiredValue === endVal)) {
              subAttributeValue = {
                class : this.searchSettings.attributesToDisplay.details[i]['sub-attribute'].class,
                value : endVal
              }
            }
          }
          details.push({
            label: this.searchSettings.attributesToDisplay.details[i].label,
            value: obj,
            subAttribute: subAttributeValue
          });

        }
      }
      return details;
    },
  },
};

</script>

